import { ShowPricesOption } from "gen/api/sale/service_pb"

export function toShowPricesOption(showPrices?: boolean): ShowPricesOption {
  if (showPrices === undefined) {
    return ShowPricesOption.UNDEFINED
  }
  return showPrices ? ShowPricesOption.SHOW : ShowPricesOption.HIDE
}
